export default "__VITE_ASSET__DvkGyBI4__"